import { SET_OUTLET } from 'components/outlets/constants'

const SetOutlet = outlet => ({
  type: SET_OUTLET,
  outlet
})

export default SetOutlet
